export default "__VITE_ASSET__BOBrqSfm__"